import request from '@/utils/request'

/**
 * 生成 AWS S3 预签名 URL
 * @param {Object} params 请求参数
 * @param {string} params.file_name 文件名
 * @returns {Promise} 返回Promise对象
 */
export function genPresignedUrl(params) {
  return request({
    url: '/api/v1/admin/aws/s3/gen_presigned_url',
    method: 'post',
    data: params
  })
}

/**
 * 使用预签名 URL 上传文件
 * @param {string} presignedUrl 预签名 URL
 * @param {File} file 要上传的文件
 * @returns {Promise} 返回Promise对象
 */
export function uploadFile(presignedUrl, file) {
  return fetch(presignedUrl, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': file.type
    }
  })
}

/**
 * 上传富文本 HTML 到 S3
 * @param {string} html 富文本 HTML 字符串
 * @returns {Promise<{success: boolean, data?: {objectUrl: string}, error?: string}>}
 */
export async function uploadHtmlToS3(html) {
  try {
    const timestamp = Date.now()
    const fileName = `notice_${timestamp}_${Math.random().toString(36).substr(2, 9)}.html`
    const response = await genPresignedUrl({ file_name: fileName })
    const { presignedUrl, objectUrl } = response.data
    const blob = new Blob([html], { type: 'text/html; charset=utf-8' })
    await uploadFile(presignedUrl, blob)
    return {
      success: true,
      data: { objectUrl, fileName },
    }
  } catch (error) {
    console.error('上传富文本失败:', error)
    return {
      success: false,
      error: error.message || '上传失败',
    }
  }
}

/**
 * 上传文件到 AWS S3（合并函数）
 * @param {File} file 要上传的文件
 * @returns {Promise} 返回Promise对象，包含上传结果
 */
export async function uploadToS3(file) {
  try {
    // 生成唯一文件名（基于原始文件名和时间戳）
    const timestamp = Date.now()
    const originalName = file.name
    const extension = originalName.split('.').pop()
    const fileName = `${timestamp}_${Math.random().toString(36).substr(2, 9)}.${extension}`

    console.log('fileName:', fileName, file.type, originalName, extension)

    // 生成预签名 URL
    const response = await genPresignedUrl({ file_name: fileName })
    const { presignedUrl, objectUrl } = response.data

    // 上传文件
    await uploadFile(presignedUrl, file)

    // 返回上传结果
    return {
      success: true,
      data: {
        objectUrl,
        fileName
      }
    }
  } catch (error) {
    console.error('上传文件失败:', error)
    return {
      success: false,
      error: error.message || '上传失败'
    }
  }
}
